import { IFieldElem } from '@models/IFormData';
import { IDictVariable, IVariable, IVariables } from '@models/Forms/IForms';
import { getValueString } from '@utils/documentUtils';
import { DictionariesService } from '@services/DictionariesService';
import { IUser } from '@models/IUser';

export class VariablesManager {
    private _variables: IVariables;
    private _docId: string;
    private _currentUser: IUser;

    constructor(variables: IVariables, docId: string, currentUser: IUser) {
        this._variables = variables;
        this._docId = docId;
        this._currentUser = currentUser;
    }

    async GetData(data: Record<string, IFieldElem>, isEdit: boolean, isNew: boolean) {
        const result = {} as Record<string, any>;

        const allIds = new Set([
            this._currentUser.id.toString(),
            ...(this._currentUser.assistantKeys || '').split(',').filter((id) => id),
            ...(this._currentUser.dummies || '').split(',').filter((id) => id),
        ]);
        const uniqueIdsArray = Array.from(allIds);

        result['docId'] = this._docId;

        result['currentUserId'] = this._currentUser.id;
        result['currentUserAssistantIds'] = uniqueIdsArray.join(',');
        result['currentUser'] = this._currentUser.name;
        result['currentUserFullName'] = this._currentUser.fullName;
        result['currentUserFirstName'] = this._currentUser.firstName;
        result['currentUserSurName'] = this._currentUser.lastName;
        result['currentUserPatronymic'] = this._currentUser.middleName;
        result['currentUserMailbox'] = this._currentUser.email;
        result['currentUserPhoneNumber'] = this._currentUser.phone;
        result['currentUserRole'] = this._currentUser.role;
        result['currentUserDepartment'] = this._currentUser.department;
        result['currentUserDepartmentId'] = this._currentUser.departmentId;
        result['currentUserPost'] = this._currentUser.position;
        result['currentUserSubdivision'] = this._currentUser.subdivision;
        result['currentUserSubdivisionInn'] = this._currentUser.subdivisionInn;
        result['currentUserWorkGroups'] = this._currentUser.workGroups;
        result['currentUserAccessGroups'] = this._currentUser.accessGroups;

        this._variables.variable.forEach((variable) => {
            if (this.checkCondition(variable, data)) {
                let val = this.getVariable(variable, data);
                result[variable.variableName] = val;
            }
        });
        for (let index = 0; index < this._variables.dictVariable.length; index++) {
            const variable = this._variables.dictVariable[index];
            if (
                (variable.onlyNew && isNew) ||
                (variable.onlyEdit && isEdit) ||
                (!variable.onlyEdit && !variable.onlyNew)
            ) {
                result[variable.variableName] = await this.getDictVariable(variable, data);
            }
        }

        return result;
    }
    private getVariable(variable: IVariable, data: Record<string, IFieldElem>) {
        let result = variable.variableFormat;
        variable.fieldVariable.forEach((variable) => {
            let val = getValueString(variable.key, data) as string;
            let localVariable = val && variable.variableFormat ? variable.variableFormat.replace('{value}', val) : '';
            let template = '{' + variable.variableName + '}';
            result = result.replace(template, localVariable ? localVariable : '');
        });
        return result;
    }
    private checkCondition(variable: IVariable, data: Record<string, IFieldElem>): boolean {
        if (!variable.condition) return true;

        let cond = variable.condition;
        variable.fieldVariable.forEach((variab) => {
            let val = getValueString(variab.key, data) as string;
            let localVariable = val && variab.variableFormat ? variab.variableFormat.replace('{value}', val) : '';
            let template = '{' + variab.variableName + '}';
            cond = cond.replace(template, localVariable ? localVariable : '');
        });
        return eval(cond);
    }
    private async getDictVariable(variable: IDictVariable, data: Record<string, IFieldElem>) {
        let code = variable.code;
        if (code.includes('|Document')) {
            code = data[code].value;
        }

        let response = await DictionariesService.getSubTreeByCode(variable.name, code);
        return response.data;
    }
}
